import { Inject, Injectable, Optional } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
    HttpResponse
} from "@angular/common/http";
import {
    CoreActionFactory,
    CoreActionFactoryToken,
} from "../../../core/redux/redux.module";
import { LoadingMaskConfigToken, LoadingMaskConfig } from "../../../component/loadingmask/loadingmask.module";
/**
 * This interceptor will update the redux state whether there is a backend request in progress or not.
 */
@Injectable()
export class CommunicationStateUpdaterInterceptor implements HttpInterceptor {
    protected _coreActionFactory: CoreActionFactory;
    protected _loadingMaskConfig: LoadingMaskConfig = {
      urlBlackList: ["/revive"]
    };

    constructor(
        @Inject(CoreActionFactoryToken)
            coreActionFactory: CoreActionFactory,
        @Inject(LoadingMaskConfigToken)
        @Optional()
            loadingMaskConfig: LoadingMaskConfig) {
        this._coreActionFactory = coreActionFactory;
        if (loadingMaskConfig) {
            this._loadingMaskConfig = loadingMaskConfig;
        }
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isLoadmaskNeeded(request.url)) {
            this._coreActionFactory.startBackendCommunication();
        }
        return  next.handle(request).pipe(tap((result: HttpResponse<any>) => {
                if (this.isLoadmaskNeeded(result.url)) {
                    this._coreActionFactory.endBackendCommunication(/* result.status ? result.status : 0 */);
                }
            }, (error: HttpErrorResponse) => {
                this._coreActionFactory.endBackendCommunication();
                this._coreActionFactory.endBackendCommunication(/*error.status ? error.status : 0 */);
            }));
    }

    isLoadmaskNeeded(url: string): boolean {
        if (!url) {
            return false;
        }
        const blacklistItem: string = this._loadingMaskConfig.urlBlackList.find((item: string) => url.indexOf(item) > -1);
        return !blacklistItem;
    }
}
